import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";

import { NoalGlobalData } from "../../../_services/eventsServices/events.service";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { FormControl, FormGroup } from "@angular/forms";

import { UserNoalOrgan } from "../user-management-models/user-noal-organ";
import { OrganType } from "../../../_models/organ-type";

@Component({
  selector: "user-management-form-activity-nests",
  templateUrl: "./user-management-form-activity-nests.component.html",
  styleUrls: [
    "user-management-form-activity-nests.component.scss",
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
  ],
})
export class UserManagementFormActivityNestsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public allAvailableOrgans: UserNoalOrgan[] = [];
  @Input("customStyle") public customStyle: "" | "thinner" = "";

  public selectedAndDeletedOrgans: UserNoalOrgan[] = [
    {
      id: 3,
      name: "טבריה",
      unique_identifier_code: "123fasd",
      parentName: "מחוז צפון",
      organType: OrganType.Nest,
      status: "exiting",
    },
    {
      id: 4,
      name: "אביהו",
      unique_identifier_code: "312313fasdf1",
      parentName: "מחוז צפון",
      organType: OrganType.Nest,
      status: "exiting",
    },
  ];
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput")
  public autoCompleteInput: ElementRef;
  public searchForm: FormGroup;
  public searchFieldName: string = "searchField";
  @Output("updateSelectedOrgans") public updateSelectedOrgans: EventEmitter<
    UserNoalOrgan[]
  > = new EventEmitter<UserNoalOrgan[]>();

  constructor(private modalService: NgbModal) {}

  @Input("noalGlobalData")
  public set noalGlobalData(value: NoalGlobalData) {
    this.setGlobalData(value);
  }

  @Input("availableOrgansToAdd")
  public set availableOrgansToAdd(value: UserNoalOrgan[]) {
    this.allAvailableOrgans = value;
  }

  @Input("chosenOrgans")
  public set chosenOrgans(value: UserNoalOrgan[]) {
    this.selectedAndDeletedOrgans = value;
    this.updateOrganStatus();
  }

  public ngOnInit(): void {
    this.searchForm = new FormGroup({});
    this.searchForm.addControl(this.searchFieldName, new FormControl(""));
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) => {
    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term): UserNoalOrgan[] => {
        return term.length < 2
          ? []
          : [...this.allAvailableOrgans]
              .filter((o) => o.status !== "exiting")
              .filter(
                (v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1
              )

              .slice(0, 10);
      })
    );
  };

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  submit() {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public organSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.searchForm.controls[this.searchFieldName].reset(null);

    const organSelected = $event.item as UserNoalOrgan;
    this.addOrganToList(organSelected);
  }

  public removeOrgan(organIndex: number) {
    const organToRemove = this.selectedAndDeletedOrgans[organIndex];
    organToRemove.status = "deleted";

    this.updateOrganStatus();
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  private updateOrganStatus() {
    this.updateSelectedOrgans.emit(
      this.selectedAndDeletedOrgans.filter((o) => o.status !== "new")
    );
  }

  private addOrganToList(eventOrgan: UserNoalOrgan) {
    const isInExistingList = this.selectedAndDeletedOrgans.find(
      (o) =>
        o.unique_identifier_code === eventOrgan.unique_identifier_code &&
        o.status === "exiting"
    );
    if (eventOrgan.status === "exiting" || isInExistingList) {
      return;
    }
    const isDeleted = this.selectedAndDeletedOrgans.find(
      (o) =>
        o.unique_identifier_code === eventOrgan.unique_identifier_code &&
        o.status === "deleted"
    );
    if (isDeleted) {
      isDeleted.status = "exiting";
    } else {
      this.selectedAndDeletedOrgans.push({ ...eventOrgan, status: "exiting" });
    }

    this.updateOrganStatus();
  }

  private updateGlobalData(organsToAdd: UserNoalOrgan[]) {
    // const existingOrgans = this.allOrgans.map(
    //   (o) => `${o.nestOrCounty}_${o.id}`
    // );
    // const organsWithoutPermission = organsToAdd.filter(
    //   (o) => !existingOrgans.includes(`${o.nestOrCounty}_${o.id}`)
    // );
    //
    // this.allOrgans.push(...organsWithoutPermission);
    //
    // this.allCounties.push(
    //   ...organsWithoutPermission
    //     .filter((o) => o.nestOrCounty === "county")
    //     .map((o) => {
    //       return {
    //         countyId: o.id,
    //         name: o.name,
    //         code: o.code,
    //         parent: o.parent,
    //         has_add_permission: o.has_add_permission,
    //       };
    //     })
    // );
    //
    // this.allNests.push(
    //   ...organsWithoutPermission
    //     .filter((o) => o.nestOrCounty === "nest")
    //     .map((o) => {
    //       return {
    //         nestId: o.id,
    //         name: o.name,
    //         code: o.code,
    //         parent: o.parent,
    //         has_add_permission: o.has_add_permission,
    //       };
    //     })
    // );
  }

  private setGlobalData(noalData: NoalGlobalData) {
    // this.allCounties = noalData.counties.map((c) => ({ ...c }));
    //
    // this.allNests = noalData.nests.map((n) => ({ ...n }));
    // this.allOrgans = [];
    //
    // const nestsAsOrgans: ActivityOrgan[] = this.allNests.map((nest) => ({
    //   code: nest.code,
    //   id: nest.nestId,
    //   isChosen: false,
    //   name: nest.name,
    //   nestOrCounty: "nest" as "nest",
    //   parent: nest.parent,
    //   //@ts-ignore
    //   fatherName: nest.fatherName,
    //   has_add_permission: nest.has_add_permission,
    // }));
    // const countiesAsOrgans: ActivityOrgan[] = this.allCounties.map(
    //   (county) => ({
    //     code: county.code,
    //     id: county.countyId,
    //     isChosen: false,
    //     name: county.name,
    //     nestOrCounty: "county" as "county",
    //     parent: county.parent,
    //     has_add_permission: county.has_add_permission,
    //     //@ts-ignore
    //     fatherName: county.fatherName,
    //   })
    // );
    // this.allOrgans = [...countiesAsOrgans, ...nestsAsOrgans];
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form-activity-nests/user-management-form-activity-nests.component.ts